import { ref } from "vue";

export const notifications = ref([]);
export const noti_position = ref("top-center"); // 기본값: 중앙 상단

export const showNotification = (message, type = "info", pos = "top-center", duration = 3000) => {
  const colors = {
    error: "#ff4d4d",
    warn: "#ffcc00",
    alarm: "#00cc66",
    info: "#3498db",
  };

  const color = colors[type] || "#3498db"; // 기본값: 파란색(info)
  noti_position.value = pos; // 위치 설정

  const newNotification = { message, color };
  notifications.value.push(newNotification);

  // 일정 시간 후 자동 삭제
  setTimeout(() => {
    notifications.value.shift();
  }, duration);
};